import React,{useEffect} from  "react";
import Slider from "react-slick";
import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  FaCheckCircle,
  FaLeaf,
  FaTruck,
  FaHeadset,
  FaCogs,
  FaTshirt,
  FaFlask,
  FaClock
} from "react-icons/fa";
import "./Slider.css";
import AOS from "aos";
import "aos/dist/aos.css";
const LaundryServices="/images/home/MorethanJustLaundry-2-png.jpg";
const GoogleRating = "/images/home/googlerating.svg"
// Custom Arrows
const PrevArrow = ({ onClick }) => (
  <div className="arrow prev" onClick={onClick}>
    <FaChevronCircleLeft />
  </div>
);

const NextArrow = ({ onClick }) => (
  <div className="arrow next" onClick={onClick}>
    <FaChevronCircleRight />
  </div>
);


const services = [
  "Shoes Cleaning and Restoration",
  "Bag Cleaning and Restoration",
  "Wedding Dress Cleaning",
  "Soft Toy Cleaning",
  "Leather Garments Cleaning",
  "Alterations",
  "Home Sanitisation",
  "Carpet Cleaning",
];

const reviews = [
  {
    text:
      "Left a winter cape for cleaning a few weeks ago: perfectly cleaned, ironed and delivered on time for reasonable price. They even fixed a hook without asking.",
    author: "SOPHIE L.",
  },
  {
    text:
      "Amazing service and very professional staff. Clothes came back spotless and perfectly folded. Pickup and delivery was super smooth. Highly recommended!",
    author: "JAMES K.",
  },
  {
    text:
      "Fast, reliable, and great quality. Customer support is very helpful and polite. Best laundry experience in the city so far.",
    author: "EMMA R.",
  },
  {
    text:
      "Outstanding attention to detail. Even small issues I didn’t mention were fixed. Truly premium service!",
    author: "MICHAEL T.",
  },
  {
    text:
      "Perfect quality and on-time delivery. Will definitely use their service again. Five stars from my side!",
    author: "SARAH P.",
  },
];

export default function SliderRating() {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1200, // small laptop
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768, // tablet
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 576, // For phones
        settings: {
          slidesToShow: 1, // Show 1 slide for phones
          slidesToScroll: 1,
        },
      },
    ],
  };


   useEffect(() => {
      AOS.init({
        duration: 1200,
        easing: "ease-in-out",
        once: true,
        offset: 80,
      });
    }, []);
  return (
    <div className="slider-wrapper">
   

       <div className="expertise-wrapper" data-aos="zoom-in-left">
  <h2 className="expertise-title">
    25+ Years of Laundry Expertise <br />
    Ready to Serve You
  </h2>

  <p className="expertise-subtitle">
    We still treat every order like it matters.
  </p>


       <div className="expertise-grid">

      <div className="expertise-card-works">
        <FaHeadset className="icon" />
        <h3>Always Reachable</h3>
        <p>
          App, WhatsApp, toll-free, live chat, or in-store — pick your channel, we’ll handle the rest.
        </p>
      </div>

      <div className="expertise-card-works">
        <FaCogs className="icon" />
        <h3>World-Class Facility</h3>
        <p>
          State-of-the-art machinery, controlled temperatures, and precision finishing for perfect results.
        </p>
      </div>

      <div className="expertise-card-works">
        <FaTshirt className="icon" />
        <h3>Specialist Garment Care</h3>
        <p>
          Kandora, Abaya, suits, sneakers, wedding gowns — each treated with the right process.
        </p>
      </div>

      <div className="expertise-card-works">
        <FaFlask className="icon" />
        <h3>Fabric-Safe Chemistry</h3>
        <p>
          Right detergent, right temperature — no shrinkage, no damage, no surprises.
        </p>
      </div>

      <div className="expertise-card-works">
        <FaClock className="icon" />
        <h3>Flexible Pickup & Delivery</h3>
        <p>
          You set the time, we show up. Built around your schedule.
        </p>
      </div>

      <div className="expertise-card-works">
        <FaLeaf className="icon" />
        <h3>Eco-Friendly Laundry</h3>
        <p>
          Sustainable practices and premium detergents for a greener clean.
        </p>
      </div>

    </div>
      </div>
      
      <section className="mtl-wrap">
        <div className="mtl-container">
          {/* LEFT IMAGES */}
          <div className="mtl-images">
            <img
            src={LaundryServices}
              alt="Laundry Services"
              className="mtl-img-main"
            />


          </div>
          {/* RIGHT CONTENT */}
          <div className="mtl-content" data-aos="zoom-out-up" style={{ textAlign: "justify" }}>
            <h2 style={{ textAlign: "start", color: "#4B2E83",fontWeight:"700" }}>More Than Just Laundry</h2>
            <h4>Unique services built around your lifestyle.</h4>
            <p>
              We don’t just stop at laundry. Our expertise includes
            </p>
            <div className="row">
              <div className="col-sm-6">
                <p>Leather Garments Cleaning</p>
                <p>Alterations</p>
                <p>Home Sanitisation</p>
                <p>Carpet Cleaning</p>
              </div>
              <div className="col-sm-6">
                <p>Shoes Cleaning and Restoration</p>
                <p>Bag Cleaning and Restoration</p>
                <p>Wedding Dress Cleaning</p>
                <p>Soft Toy Cleaning</p>
        
              </div>
 
            </div>
            {/* <img
            src="https://berqwp-cdn.sfo3.cdn.digitaloceanspaces.com/cache/5asec.ae/wp-content/uploads/2024/03/newiconsLe-png.webp?bwp"
            alt="Laundry Icons"
            className="mtl-img-icons"
          /> */}
          </div>
        </div>
      </section>

    </div>
  );
}
